import React from "react";
import SessionBox from "../form/SessionBox";
import { Row, Col } from "antd";

const QuestionBox = (props)=> {
	console.log(props);
	return (
		<div>
			<Row gutter={16}>
				<Col span={12} style={{ minHeight: 157,height:"100%",display:"flex"}} >
					<SessionBox value={500} text={"testsada"} cardStyle={{width:"100%"}} 
						innerStyle={{alignItems:"center",display:"flex",height:"100%"}}/>
				</Col>
				<Col span={12} >
					<Row><SessionBox value={50} text={"testsada"} /></Row>
					<Row style={{paddingTop:10}}><SessionBox value={50} text={"testsada"}/></Row>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={24}  style={{paddingTop:10,minHeight: 300,height:"100%",display:"flex"}}>
					<SessionBox value={50} text={"testsada"} cardStyle={{width:"100%"}} 
						innerStyle={{alignItems:"center",display:"flex",height:"100%"}} />
				</Col>
			</Row>
		</div>
	);};

            
export default QuestionBox;


// WEBPACK FOOTER //
// ./src/components/form/QuestionBox.js